let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5vVwY")).then(() => parcelRequire('2AqIL'));